import * as apiClient from "./axiosApiClient";
import { joinUrlWithRoute } from "../utils/urlUtils";

const baseUrl = apiClient.REACT_APP_EXECUTIVE_REPORTS_API_BASE_URL;

export const getExecutiveReports = () => apiClient.get(baseUrl);
export const createExecutiveReport = (payload) => apiClient.post(baseUrl, payload);
export const updateExecutiveReport = (id, payload) => apiClient.put(joinUrlWithRoute(baseUrl, `/${id}`), payload);
export const deleteExecutiveReport = (id) => apiClient.httpDelete(joinUrlWithRoute(baseUrl, `/${id}`));
export const runExecutiveReportNow = (id) => apiClient.post(joinUrlWithRoute(baseUrl, `/${id}/run-now`), {});
export const createExecutiveReportViewLink = (runId) => apiClient.post(joinUrlWithRoute(baseUrl, `/runs/${runId}/view-link`), {});
export const getExecutiveReportRun = (runId) => apiClient.get(joinUrlWithRoute(baseUrl, `/runs/${runId}`));
export const requestExecutiveReportPdf = (runId) => apiClient.post(joinUrlWithRoute(baseUrl, `/runs/${runId}/pdf`), {});
export const downloadExecutiveReportPdf = (runId) => apiClient.get(joinUrlWithRoute(baseUrl, `/runs/${runId}/pdf`), { responseType: "blob" });
